import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import * as confirmAction from "../../../store/confirm/action";
import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";

import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Table,
} from "reactstrap";
import {
  GET_ALLOCATE_CONF,
  GET_ALLOCATE_DATA,
  baseUrl,
} from "../../../helpers/url_api_constant";
import { Link, useHistory, useParams } from "react-router-dom";

import React, { useEffect, useState } from "react";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";

import BootstrapTable from "react-bootstrap-table-next";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import { post } from "../../../helpers/api_helper";
import { withTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
// import { baseUrl } from "../../../helpers/url_api_constant";

function AllocationDetail(props) {
  let history = useHistory();
  let { pid } = useParams();

  const dispatch = useDispatch();

  const permission = getPermission();
  const searchObj = { ALLOCATE_PID: pid, SHIPPER_NAME: "", CONRACT_POINT: "", POINT_VALUE: "", NOMINATE_NAME: "", };
  // const createObj = {};
  const pidInfoAllocate = { PID: pid };
  const [dataDetailAllocate, setDataDetailAllocate] = useState({});
  const [modelDeviceList, setModelDeviceList] = useState([]);
  // const [createModel, setCreateModel] = useState(createObj);
  const [searchModel, setSearchModel] = useState(searchObj);

  const listData = [
    {
      Id: "1",
      GasDay: "02/05/2021",
      Shipper: "PTT",
      Contact: "2016-CLF-001",
      Nomination: "AAA",
      Point: "EXIT",
      BookedCap: "17.474",
      NominatedValue: "8.591",
      AllocationTPA: "8.475",
      Usage: "48.50",
      Timestamp: "03/05/2021 03:27 PM",
    },
    {
      Id: "2",
      GasDay: "01/05/2021",
      Shipper: "PTT",
      Contact: "2016-CLF-001",
      Nomination: "AAA",
      Point: "EXIT",
      BookedCap: "17.474",
      NominatedValue: "8.591",
      AllocationTPA: "8.565",
      Usage: "49.02",
      Timestamp: "02/05/2021 03:27 PM",
    },
    {
      Id: "3",
      GasDay: "01/05/2021",
      Shipper: "PTT",
      Contact: "2016-CLF-001",
      Nomination: "ABP1",
      Point: "EXIT",
      BookedCap: "17.474",
      NominatedValue: "11.811",
      AllocationTPA: "2.128",
      Usage: "12.18",
      Timestamp: "02/05/2021 03:27 PM",
    },
    {
      Id: "4",
      GasDay: "01/05/2021",
      Shipper: "PTT",
      Contact: "2016-CLF-001",
      Nomination: "ABP2",
      Point: "EXIT",
      BookedCap: "17.474",
      NominatedValue: "12.625",
      AllocationTPA: "12.142",
      Usage: "69.49",
      Timestamp: "02/05/2021 03:27 PM",
    },
    {
      Id: "5",
      GasDay: "01/05/2021",
      Shipper: "PTT",
      Contact: "2016-CLF-001",
      Nomination: "ABP3",
      Point: "EXIT",
      BookedCap: "17.474",
      NominatedValue: "10.384",
      AllocationTPA: "3.760",
      Usage: "21.52",
      Timestamp: "02/05/2021 03:27 PM",
    },
    {
      Id: "6",
      GasDay: "01/05/2021",
      Shipper: "PTT",
      Contact: "2016-CLF-001",
      Nomination: "ABP4",
      Point: "EXIT",
      BookedCap: "17.474",
      NominatedValue: "8.542",
      AllocationTPA: "7.529",
      Usage: "43.09",
      Timestamp: "02/05/2021 03:27 PM",
    },
    {
      Id: "7",
      GasDay: "01/05/2021",
      Shipper: "PTT",
      Contact: "2016-CLF-001",
      Nomination: "ABPR1",
      Point: "EXIT",
      BookedCap: "17.474",
      NominatedValue: "8.586",
      AllocationTPA: "11.796",
      Usage: "67.51",
      Timestamp: "02/05/2021 03:27 PM",
    },
    {
      Id: "8",
      GasDay: "01/05/2021",
      Shipper: "PTT",
      Contact: "2016-CLF-001",
      Nomination: "ABPR2",
      Point: "EXIT",
      BookedCap: "17.474",
      NominatedValue: "5.508",
      AllocationTPA: "10.502",
      Usage: "60.10",
      Timestamp: "02/05/2021 03:27 PM",
    },
    {
      Id: "9",
      GasDay: "01/05/2021",
      Shipper: "PTT",
      Contact: "2016-CLF-001",
      Nomination: "ABPR3",
      Point: "EXIT",
      BookedCap: "17.474",
      NominatedValue: "8.365",
      AllocationTPA: "7.456",
      Usage: "42.67",
      Timestamp: "02/05/2021 03:27 PM",
    },
    {
      Id: "10",
      GasDay: "01/05/2021",
      Shipper: "PTT",
      Contact: "2016-CLF-001",
      Nomination: "ABPR4",
      Point: "EXIT",
      BookedCap: "17.474",
      NominatedValue: "8.629",
      AllocationTPA: "7.131",
      Usage: "40.81",
      Timestamp: "02/05/2021 03:27 PM",
    },
  ];

  const gotoAllocationData = () => {
    // history.push("/allocation-data");
    history.push({
      pathname: "/allocation-data", state: {  // location state
        goBack: true,
      },
    });
  };

  //sort Column//
  const defaultSorted = [
    {
      dataField: "NOMINATE_NAME",
      order: "asc",
    },
  ];
  //sort Column//

  //Sort Page//
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total ms-2">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "100",
        value: 100,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "750",
        value: 750,
      },
      {
        text: "1000",
        value: 1000,
      },
    ],
  };
  //Sort Page//


  //render Index//
  const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;
  //render Index//

  //format date 
  const FormatDate = (date, format) => {
    return (
      <div>
        {moment(date).format(
          format
        )}
      </div>
      // Sep-21
    );
  };
  //format date

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = 'white';

    return style;
  };


  //headerColumn
  const columns = [
    {
      dataField: "Dummy",
      text: "No.",
      headerAlign: 'center',
      align: 'center',
      headerStyle: {
        width: "5%",
        fontSize: "12px",
      },
      style: {
        width: "5%",
        fontSize: "12px",
      },
      formatter: CountIndexRow,
    },
    {
      dataField: "LOAD_DATE",
      text: "Gas Day",
      headerAlign: 'center',
      align: 'center',
      headerStyle: {
        width: "10%",
        fontSize: "12px",
      },
      style: {
        width: "10%",
        fontSize: "12px",
      },
      sort: true,
      isDummyField: true,
      formatter: (cellContent, row) => FormatDate(row.LOAD_DATE, "DD/MM/YYYY"),
    },
    {
      dataField: "SHIPPER_NAME",
      text: "Shipper Code",
      headerAlign: 'center',
      align: 'center',
      headerStyle: {
        width: "10%",
        fontSize: "12px",
      },
      style: {
        width: "10%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "CONRACT_POINT",
      text: "Contact Code",
      headerAlign: 'center',
      align: 'center',
      headerStyle: {
        width: "10%",
        fontSize: "12px",
      },
      style: {
        width: "10%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "NOMINATE_NAME",
      text: "Nomination Point ID",
      headerAlign: 'center',
      align: 'center',
      headerStyle: {
        width: "10%",
        fontSize: "12px",
      },
      style: {
        width: "10%",
        fontSize: "12px",
      },
      sort: true,
    },

    {
      dataField: "POINT_VALUE",
      text: "Point Type",
      headerAlign: 'center',
      align: 'center',
      headerStyle: {
        width: "10%",
        fontSize: "12px",
      },
      style: {
        width: "10%",
        fontSize: "12px",
      },
      sort: true,
    },
    // {
    //   dataField: "SHOW_BOOKEDCAP",
    //   text: "Booked Cap.(MMBTU/D)",
    //   headerAlign: 'center',
    //   align: "right",
    //   headerStyle: {},
    //   // sort: true,
    // },
    {
      dataField: "SHOW_NOMINATE_VALUE",
      text: "Nominated Value (MMBTU/D)",
      headerAlign: 'center',
      align: "right",
      headerStyle: {
        width: "15%",
        fontSize: "12px",
      },
      style: {
        width: "15%",
        fontSize: "12px",
      },
      // sort: true,
    },
    {
      dataField: "SHOW_ALLOCATE_TPA",
      text: "Allocation TPA (MMBTU/D)",
      headerAlign: 'center',
      align: "right",
      headerStyle: {
        width: "15%",
        fontSize: "12px",
      },
      style: {
        width: "15%",
        fontSize: "12px",
      },
      // sort: true,
    },
    // {
    //   dataField: "SHOW_USAGE",
    //   text: "Usage (%)",
    //   align: "right",
    //   headerAlign: 'center',
    //   headerStyle: {},
    //   // sort: true,
    // },
    {
      dataField: "TIMESTAMP",
      text: "Timestamp",
      headerAlign: 'center',
      align: 'center',
      headerStyle: {
        width: "15%",
        fontSize: "12px",
      },
      style: {
        width: "15%",
        fontSize: "12px",
      },
      isDummyField: true,
      formatter: (cellContent, row) => FormatDate(row.TIMESTAMP, "DD/MM/YYYY, HH:mm:ss"),
      // sort: true,
    },
  ];
  //headerColumn
  //onInit//
  useEffect(function () {
    resetSearch();
    // resetModel();allocation-detail-table
    // setModelDeviceList(listData);

    ///fixed header table
    let tableId = "allocation-detail-table";
    let scrollY = 335;
    function fixedTableHeader() {
      let headerTable = document.querySelector(`#${tableId} thead`);
      if (window.scrollY >= scrollY) {
        headerTable.classList.add("fixed-header");

        resizeTableHeader();
      } else {
        headerTable.classList.remove("fixed-header");
      }
    }
    function resizeTableHeader() {
      setTimeout(() => {
        let headerTable = document.querySelector(`#${tableId} thead`);
        let tr = document.querySelector(`#${tableId} tbody tr`);
        let th = headerTable.querySelector(".header-style");
        if (tr) {
          for (var i = 0; i < tr.childNodes.length; i++) {
            th.childNodes[i].style.width = `${tr.childNodes[i].offsetWidth}px`;
          }
        }
      }, 1);
    }
    window.addEventListener("scroll", fixedTableHeader);
    document
      .querySelector(`#vertical-menu-btn`)
      .addEventListener("click", resizeTableHeader);
    return () => {
      window.removeEventListener("scroll", fixedTableHeader);
      document.querySelector(`#vertical-menu-btn`)?.removeEventListener("click", resizeTableHeader);
    };
  }, []);
  //onInit//

  //Function CURL
  const resetSearch = () => {
    setSearchModel(searchObj);
    fetchData(searchObj);
    getDataDetailAllocate(pidInfoAllocate);
  };

  const onSearch = () => {
    // console.log(searchModel);
    fetchData(searchModel);
  };

  const getDataDetailAllocate = async (pidAllocate) => {
    //  dispatch(loadingAction.showLoading());
    try {
      let res = await post(GET_ALLOCATE_CONF, pidAllocate);
      // console.log(res);
      setDataDetailAllocate(res.data.allocateConfList[0]);
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    //  dispatch(loadingAction.hideLoading());
  };

  const fetchData = async (searchData) => {
    // console.log(searchData);
    const objSearch = {
      ...(searchData.SHIPPER_NAME != '') && { SHIPPER_NAME: searchData.SHIPPER_NAME },
      ...(searchData.CONRACT_POINT != '') && { CONRACT_POINT: searchData.CONRACT_POINT },
      ...(searchData.POINT_VALUE != '') && { POINT_VALUE: searchData.POINT_VALUE },
      ...(searchData.NOMINATE_NAME != '') && { NOMINATE_NAME: searchData.NOMINATE_NAME },
      ALLOCATE_PID: searchData.ALLOCATE_PID
    }
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(GET_ALLOCATE_DATA, objSearch);
      // console.log(res);
      setModelDeviceList(res.data.allocateDataList);
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const downloadExcel = () => {
    dispatch(loadingAction.showLoading());
    const accessToken = JSON.parse(localStorage.getItem("accessToken"));
    fetch(baseUrl + "api/DownloadFile/downloadExcelAllocateFile?ALLOCATE_PID=" + pid, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/vnd.ms-excel',
        'Authorization': "Bearer " + accessToken.access_token,
        'TSOSESSIONID': getUserToken(),
      },
    })
      .then((response) => response.blob())
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(
          new Blob([blob]),
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          // `FileName.xlsx`,
          dataDetailAllocate.UPLOAD_FILE
        );

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
        dispatch(loadingAction.hideLoading());
      });

  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h1 className="mb-sm-0 font-size-20">
                      {" "}
                      {props.t("Allocation Data ( Detail )")}
                    </h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            Input Management
                          </Link>
                        </li>
                        <li className="breadcrumb-item">
                          <Link to="/allocation-data" style={{ color: "#556ee6" }}>
                            Allocation Data
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">
                          Allocation Data ( Detail )
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div>
                    <span style={{ fontSize: "17px", color: "#FFFFFF" }}> Gas Day : </span>&nbsp;&nbsp;<span style={{ fontSize: "17px", color: "#556ee6" }}>{moment(dataDetailAllocate.UPLOAD_START).format(
                      "DD/MM/YYYY"
                    )}</span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span style={{ fontSize: "17px", color: "#FFFFFF" }}>Type : </span>&nbsp;&nbsp;<span style={{ fontSize: "17px", color: "#556ee6" }}>{dataDetailAllocate.UPLOADTYPE_NAME}</span>
                  </div>
                  <hr />
                  <Row>
                    <Col sm="5">
                      <FormGroup className="row mt-3">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Shipper Code
                        </Label>
                        <Col sm={8}>
                          <div className="search-box">
                            <div className="position-relative">
                              <input
                                type="text"
                                // style={{backgroundColor:"#FFFFFF"}}
                                className="form-control rounded-2 basicborder"
                                placeholder={props.t("Search Shipper Code")}
                                onChange={e =>
                                  setSearchModel({
                                    ...searchModel,
                                    SHIPPER_NAME: e.target.value,
                                  })
                                }
                                value={searchModel.SHIPPER_NAME}
                              />
                              {/* {props.t("Search Meter Point ID") + "..."} */}
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm="5">
                      <FormGroup className="row mt-3">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Contact Code
                        </Label>
                        <Col sm={8}>
                          <div className="search-box">
                            <div className="position-relative">
                              <input
                                type="text"
                                // style={{backgroundColor:"#FFFFFF"}}
                                className="form-control rounded-2 basicborder"
                                placeholder={props.t("Search Contact Code")}
                                onChange={e =>
                                  setSearchModel({
                                    ...searchModel,
                                    CONRACT_POINT: e.target.value,
                                  })
                                }
                                value={searchModel.CONRACT_POINT}
                              />
                              {/* {props.t("Search Meter Point ID") + "..."} */}
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="5">
                      <FormGroup className="row mt-3">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Nomination Point ID
                        </Label>
                        <Col sm={8}>
                          <div className="search-box">
                            <div className="position-relative">
                              <input
                                type="text"
                                // style={{backgroundColor:"#FFFFFF"}}
                                className="form-control rounded-2 basicborder"
                                placeholder={props.t("Search Nomination Point ID")}
                                onChange={e =>
                                  setSearchModel({
                                    ...searchModel,
                                    NOMINATE_NAME: e.target.value,
                                  })
                                }
                                value={searchModel.NOMINATE_NAME}
                              />
                              {/* {props.t("Search Meter Point ID") + "..."} */}
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm="5">
                      <FormGroup className="row mt-3">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Point Type
                        </Label>
                        <Col sm={8}>
                          <div className="search-box">
                            <div className="position-relative">
                              <input
                                type="text"
                                // style={{backgroundColor:"#FFFFFF"}}
                                className="form-control rounded-2 basicborder"
                                placeholder={props.t("Search Point Type")}
                                onChange={e =>
                                  setSearchModel({
                                    ...searchModel,
                                    POINT_VALUE: e.target.value,
                                  })
                                }
                                value={searchModel.POINT_VALUE}
                              />
                              {/* {props.t("Search Meter Point ID") + "..."} */}
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm="2">
                      <FormGroup className="row">
                        <div className="d-flex align-items-center justify-content-end">
                          <Button color="info" className="mt-3" onClick={() => onSearch()}>
                            <i className="fas fa-search"></i>
                            &nbsp; Search
                          </Button>

                          <Button color="warning" className="mt-3 ms-2" onClick={() => resetSearch()}>
                            <i className="fas fa-redo-alt"></i>
                            &nbsp; Reset
                          </Button>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row className="mb-2 mt-3">
                    <Col sm="3">
                      <div className="d-grid gap-2 d-md-block">
                        {/* {permission.eALD && ( */}
                          <Button
                            color="success"
                            className="mt-2 mb-2"
                            onClick={() => downloadExcel()}
                          >
                            <i className="fas fa-file-download fa-lg"></i>
                            &nbsp; Download Excel
                          </Button>
                        {/* )} */}
                      </div>
                    </Col>
                    <Col
                      sm="9"
                      className="d-flex align-items-center justify-content-end"
                    >
                      <div className="d-grid gap-2 d-md-block">
                        <Button
                          onClick={() => gotoAllocationData()}
                          // className="btn-rounded"
                          color="secondary"
                          className="mt-2 mb-2"
                        >
                          <i className="fas fa-angle-double-left"></i>
                          &nbsp; Back
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="12">
                      <div>
                        {/* className="table-responsive" */}
                        <BootstrapTable
                          id="allocation-detail-table"
                          keyField="PID"
                          data={modelDeviceList}
                          columns={columns}
                          headerClasses="header-style"
                          rowStyle={rowStyleFontWhite}
                          defaultSorted={defaultSorted}
                          pagination={paginationFactory(options)}
                        // hover
                        />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

AllocationDetail.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ AllocationDetail }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(AllocationDetail));

// function RenderList(prop) {
//   console.log(prop);

//   return (<tr>
//     <td>{prop.indexlist}</td>
//     <td>{prop.data.MeterPointID}</td>
//     <td>{prop.data.Customer}</td>
//     <td>{prop.data.CustomerType}</td>
//     <td>{prop.data.CommunicationType}</td>
//     <td>{prop.data.Zone}</td>
//     <td>{prop.data.Point}</td>
//     <td>{prop.data.Region}</td>
//     <td>{prop.data.Area}</td>
//     <td>{prop.data.BVZoning}</td>
//     <td>{prop.data.BV}</td>
//     <td>
//       <Button className="me-1"
//         onClick={() =>
//           setPageAdd(true)
//         }
//         color="info"
//       >
//         <i className="far fa-edit"></i>
//         &nbsp; Edit
//       </Button>
//       <Button
//         onClick={() =>
//           setModalDelete(true)
//         }
//         // className="btn-rounded"
//         color="danger"
//       >
//         <i className="fas fa-trash-alt"></i>
//         &nbsp; Delete
//       </Button>
//     </td>
//   </tr>)
// }
